module.exports = require('./helpers/bundle-url').getBundleURL('aK4Nu') + "WETH.6226dbd9.svg";